import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import { useBillCreditNotes } from './useBillCreditNotes';
import { useSettleCreditNote } from './useSettleCreditNote';

/** Credit notes already issued against one bill — shown inline under the
 * bill row, with a "Settle" action for any still owed to the patient. */
export default function CreditNotesPanel({ billId }: { billId: number }) {
  const query = useBillCreditNotes(billId);
  const settle = useSettleCreditNote(billId);
  const notes = query.data ?? [];

  if (query.isLoading || notes.length === 0) return null;

  return (
    <div className="mt-2 space-y-1.5 border-t border-line pt-2">
      {notes.map((n) => (
        <div key={n.id} className="flex items-center justify-between text-[11.5px]">
          <div>
            <span className="font-mono text-ink-muted">{n.credit_note_number}</span>{' '}
            <span className="text-danger-ink">− ₹{parseFloat(n.total_amount).toFixed(2)}</span>{' '}
            <span className="text-ink-muted">· {n.reason}</span>
          </div>
          {n.refund_status === 'Pending' ? (
            <div className="flex items-center gap-1.5">
              <Badge variant="warn">Owed</Badge>
              <Button
                variant="ghost"
                size="sm"
                disabled={settle.isPending && settle.variables?.creditNoteId === n.id}
                onClick={() => settle.mutate({ creditNoteId: n.id })}
              >
                {settle.isPending && settle.variables?.creditNoteId === n.id ? '…' : 'Settle'}
              </Button>
            </div>
          ) : (
            <Badge variant="success">Refunded</Badge>
          )}
        </div>
      ))}
    </div>
  );
}
